export default "__VITE_ASSET__a5f0364f__"